import script from "./PremiumContent.vue?vue&type=script&setup=true&lang=js"
export * from "./PremiumContent.vue?vue&type=script&setup=true&lang=js"

import "./PremiumContent.vue?vue&type=style&index=0&id=2dfeb878&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dfeb878"]])

export default __exports__